import { render } from "./RecentTransactionsWidget.vue?vue&type=template&id=7f8ce891"
import script from "./RecentTransactionsWidget.vue?vue&type=script&lang=js"
export * from "./RecentTransactionsWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__